module.exports = __webpack_public_path__ + "img/LobstermaniaSlots_2208x1242_9.368dc022.png";